// extracted by mini-css-extract-plugin
export default {"dayBoxTitle":"DayBox_dayBoxTitle__IDd47"};